import { render, staticRenderFns } from "./DonutChart27.vue?vue&type=template&id=e4bd7136&scoped=true"
import script from "./DonutChart27.vue?vue&type=script&lang=js"
export * from "./DonutChart27.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4bd7136",
  null
  
)

export default component.exports